(ns nl.mediquest.be-my-coach-frontend.views.react-helpers
  "DOM-node helpers. Reagent 2 / React 19 removed `reagent.dom/dom-node` (and
  React's `findDOMNode`), so these are expressed with React refs instead. Both are
  function components - render them with `:f>`."
  (:require
   ["react" :refer [useRef useEffect]]))

(defn focus-on-mount
  "Focuses the first element of `body` once it is mounted."
  [body]
  (let [ref (useRef)]
    (useEffect
     (fn []
       (some-> (.-current ref) .-firstElementChild .focus)
       js/undefined)
     #js [])
    [:div {:ref ref} body]))

(defn scroll-into-view
  "Scrolls `child` into view whenever `pred` is true, using `scroll-options`."
  [{:keys [pred scroll-options]} child]
  (let [ref (useRef)]
    (useEffect
     (fn []
       (when pred
         (some-> (.-current ref) (.scrollIntoView scroll-options)))
       js/undefined)
     #js [pred])
    [:div {:ref ref} child]))
